<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal suggested-address-modal">
            <div class="modal__header">
                <h2 class="headline-s">Use Suggested Address?</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body">
                <div class="address">
                    <h4>Old Address</h4>
                    <p v-for="field in oldAddress" :key="`old_${field}`">{{ field }}</p>
                </div>
                <div class="address">
                    <h4>New Address</h4>
                    <p v-for="field in newAddress" :key="`new_${field}`">{{ field }}</p>
                </div>
            </div>
            <div class="actions">
                <RothcoCta class="primary" id="submitButton" @click="submit()">Yes</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>

    import { computed, inject } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');



    const closeDialog = (props) => {
        dialogRef?.value?.close(props);
    }

    const oldAddress = computed(()=>{
        return dialogRef?.value?.data.oldAddress;
    })

    const newAddress = computed(()=>{
        return dialogRef?.value?.data.newAddress;
    })

    const submit = (()=>{
        closeDialog({ useSuggestedAddress: true });
    })
</script>
